import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { NgClass } from '@angular/common';
import dayjs from 'dayjs';

@Component({
  selector: 'today-pastille',
  templateUrl: './today-pastille.component.html',
  styleUrl: './today-pastille.component.css',
  standalone: true,
  imports: [IonicModule, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TodayPastilleComponent {
  fill = input.required<boolean>();
  pastilleClicked = output();

  todayMoment = signal<number>(dayjs().date());

  onPastilleClicked() {
    this.pastilleClicked.emit();
  }
}
